import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JgVisualInspUnitFbDetail } from '../models/jg/jg-visual-insp-unit-fb-detail.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class JgVisualInspUnitFbDetailService extends RequestService<JgVisualInspUnitFbDetail> {
  static PATH = '/jg/visualInsp/unit/unitFb/detail';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(
      httpClient,
      JgVisualInspUnitFbDetailService.PATH,
      globalService.debugUrl,
    );
  }
}
